export default __webpack_public_path__ + "static/media/gothenburg_background_s1.40ec69f9.jpg";